import type { ErrorFallbackProps } from "./ErrorBoundary";

import { ContentFull } from "./ContentLayout";
import { ErrorDetail } from "./ErrorDetail";

export function ContentNotFound({ errorDetail }: ErrorFallbackProps) {
  return (
    <ContentFull>
      <div className="flex flex-col items-center justify-center gap-4 p-12">
        <h2 className="font-title">
          <ErrorDetail error={errorDetail} />
        </h2>
        <div className="flex flex-row items-center gap-4 font-title">
          ? <img src="/turtle.svg" alt="Confused turtle" /> ?
        </div>
      </div>
    </ContentFull>
  );
}
